export default __webpack_public_path__ + "static/media/25082603.37080cf6.png";